
let refs = {};

window.__refs = refs;

function addRefs(newRefs = {}) {

    for (let entry of Object.entries(newRefs)) {
        if (refs[entry[0]]) {
            throw `Ref "${entry[0]}" already is set!`;
        }
        refs[entry[0]] = entry[1];
    }
}

function getRef(name) {
    if (!refs[name]) {
        throw `Unknown reference "${name}". Please ensure apps have booted correctly! (Are you missing a ref attributed?)`
    }

    return refs[name];
}

export {
    addRefs,
    getRef
}

